import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import theme from 'theme/theme';
import { DeactivateIcon } from 'assets/materialIcons/materialIcons';

const AddRelatedButton = (props) => {
    const { handleAdd } = props;

    return (
        <IconButton
            onTouchTap={ () => {
                handleAdd();
            } }
        >
            <DeactivateIcon
                color={ theme.palette.silver }
                hoverColor={ theme.palette.secondary }
            />
        </IconButton>
    );
};

AddRelatedButton.propTypes = {
    handleAdd: PropTypes.func.isRequired,
};

export default AddRelatedButton;



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/buttons/AddRelatedButton.js